import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/kynd-points',
    name: 'kyndPoints',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "kynd-points-index" */ './views/index.vue')
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        handleRoute()
        function handleRoute() {
          store
            // fetch admin users
            .dispatch('kyndPoints/fetchLists')
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'kyndPoints' } })
            })
        }
      },
    },
  },
]
